import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import PosterAcrediatacao from "./acreditacoes_site_FCI.jpg";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
import { SocialView } from "../SocialView/SocialView";
import { FooterNote } from "../FooterLinks/FooterNote";
import { SearchView } from "../SearchView/SearchView";
import { TicketForm } from "./TicketForm";
import { initialize } from "redux-form";
import { fetchMenusIfNeeded, storeTicketRequest } from "../../actions";

export class TicketFormView extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchMenusIfNeeded(this.props.selectedScope));
  }

  componentWillReceiveProps(nextProps) {
    const { selectedScope, dispatch } = nextProps;
    if (selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(selectedScope));
    }
  }

  handleSubmit(req) {
    const { dispatch } = this.props;
    // chamar uma acção para fazer o post dos dados

    // {name: "teste", company: "okokok", email: "tpsaraujo@gmail.com", telf: "dfwe352"}
    dispatch(storeTicketRequest(req));

    const initialFormData = ["name", "company", "email", "telf"];
    // console.log('handleSubmit', this.props)

    dispatch(
      initialize(
        "contact",
        {
          name: "",
          company: "",
          email: "",
          telf: ""
        },
        initialFormData
      )
    ); // clear form
  }

  gotoPage = page => {
    this.props.history.push("/pesquisa");
  };

  render() {
    const { menus, dispatch } = this.props;
    const bottom_menus = menus.bottom || [];
    const top_menus = menus.top || [];
    let t = this.props.ticket;

    if (typeof t === "undefined") {
      t = {};
    }
    // console.log('ticket', t)
    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div id="presentation-view" className="row team-view">
          <div className="col-md-12 no-pad text-left">
            <p className="left-tag">Acreditações</p>
            <SearchView
              gotoPage={this.gotoPage}
              dispatch={dispatch}
              customStyle={"alignright"}
            />
          </div>
          <div className="row main-block">
            <div className="col-sm-4 col-md-4 col-lg-3  side-block no-pad">
              <img className="thumb" src={PosterAcrediatacao} />
            </div>
            <div className="col-sm-8 col-md-offset-1 col-md-7 col-lg-8">
              <h4 style={{ marginBottom: "25px" }}>
                PARA PEDIDOS DE ACREDITAÇÃO, POR FAVOR PREENCHA ESTE FORMULÁRIO
              </h4>
              <div className="col-sm-12 col-lg-8 no-pad-left">
                <TicketForm onSubmit={this.handleSubmit} />
                <div>
                  {Object.keys(t).length > 0 ? (
                    <p style={{ marginTop: "-20px" }}>
                      <strong>Pedido enviado com sucesso.</strong>
                    </p>
                  ) : (
                    <p />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus} />
        <SocialView customclass="lite" />
        <FooterNote />
      </div>
    );
  }
}

TicketFormView.propTypes = {
  dispatch: PropTypes.func.isRequired,

  menus: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
  ticket: PropTypes.object.isRequired,
  selectedScope: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  const { getMenus, getTickets, selectedScope } = state;

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    selectedScope
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingTicket, items: ticket } = getTickets["ticket"] || {
    isFetchingTicket: true,
    items: {}
  };

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    isFetchingTicket,
    ticket,
    selectedScope,
    menus
  };
}

export default connect(mapStateToProps)(TicketFormView);



// WEBPACK FOOTER //
// ./src/views/AboutView/TicketFormView.js